(function () {
    const OFFSET = 120;
  
    function scrollWithOffset() {
      const id = window.location.hash.slice(1);
      if (!id) return;
  
      const el = document.getElementById(id);
      if (!el) return;
  
      const y =
        el.getBoundingClientRect().top +
        window.pageYOffset -
        OFFSET;
  
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  
    window.addEventListener("load", () => {
      setTimeout(scrollWithOffset, 50);
    });
  
    window.addEventListener("hashchange", scrollWithOffset);
  })();